<template>
  <app-layout>
    <template #header>
      <div class="text-center print:text-left">
        <h1 class="text-2xl">Bestellreklamation</h1>
        <p class="text-base">Für meine Bestellung vom <b>{{ $page.props.formattedOrderDate }}</b>, KW {{ $page.props.weekOfYear }}</p>
      </div>

      <div
        v-if="$page.props.flash.success"
        class="flex items-center justify-center p-6 bg-green-100 text-lg text-green-800 relative z-30 max-w-5xl mx-auto my-8 print:none">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 flex-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        {{ $page.props.flash.success }}
      </div>
    </template>

    <div class="max-w-2xl mx-auto px-4 md:px-6 sm:flex">
      <Link
        :href="route('complaint', { order: $page.props.order })"
        class="flex items-center justify-center my-4 sm:my-0 text-center w-full sm:w-1/2 p-6 border border-black hover:bg-black hover:text-white active:opacity-75 transition-all text-xl"
        :class="{'pointer-events-none opacity-40': !complaintSubmittable}"
        >
        Stückzahl & Qualität
      </Link>
      <Link
        :href="route('complaint-deposit', { order: $page.props.order })"
        target="_blank"
        class="flex items-center justify-center my-4 sm:my-0 text-center w-full sm:mx-6 sm:w-1/2 p-6 border border-black hover:bg-black hover:text-white active:opacity-75 transition-all text-xl"
        :class="{'pointer-events-none opacity-40': !complaintSubmittable}">
        Leergut
      </Link>
    </div>
    <div class="max-w-2xl mx-auto px-4 md:px-6">
      <div class="mt-4"><strong>Hinweis</strong>: Bestellungen können nur am <strong>Liefertag bis {{ complaintSubmittableTill }} Uhr </strong> reklamiert werden</div>

      <h3 class="text-xl font-semibold mb-2 mt-8">Eingereichte Reklamationen:</h3>
      <div v-if="$page.props.complaints && $page.props.complaints.length > 0">
        <ul class="list-disc pl-4">
          <li v-for="complaint in $page.props.complaints" :key="complaint.id">
            <Link v-if="complaint.type === 'deposit'" :href="route('show-complaint-deposit', complaint)" class="underline hover:no-underline">
              Leergut, {{ formatDate(complaint.created_at) }}
            </Link>
            <Link v-else :href="route('show-complaint', complaint)" class="underline hover:no-underline">
              Menge & Qualität, {{ formatDate(complaint.created_at) }}
            </Link>
          </li>
        </ul>
      </div>
      <div v-else>
        -
      </div>
    </div>
  </app-layout>
</template>

<script>
import format from 'date-fns/format'
import{ Link } from "@inertiajs/inertia-vue3"

import AppLayout from '@/Layouts/AppLayout'

export default {
  components: {
    AppLayout,
    Link
  },

  computed: {
    complaintSubmittable() {
      return this.$page.props.complaintSubmittable
    },

    complaintSubmittableTill() {
      return this.$page.props.complaintSubmittableTill
    }
  },

  methods: {
    formatDate(dateString) {
      const date = new Date(dateString)
      const dateFormat = format(date, 'dd.MM.yyyy')
      const timeFormat = format(date, 'H:mm')

      return `${timeFormat} Uhr (${dateFormat})`
    }
  }
}
</script>
